import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    createCopyLink,
    generateUUID2,
    getImagePathWithTheme,
    getImagePathWithThemeSvg, getItem,
    getNoteFirstHtmlForLeftCard, getSafeInt,
    imgPathPerfix, isAudio, isAudioFileElement, isFileElement, isFileVideoElement, isLiveVideoElement, isLiveVideoType,
    isNoteElement, isPdf, isPdfFileElement, isVideo,
    removeHtmlTags
} from "../../utils";
import {Button, ConfigProvider, Dropdown, Flex, Input, Modal, Tree} from "antd";
const {DirectoryTree} = Tree;
import {FieldDataNode} from "rc-tree/lib/interface";
import {
    CaretDownOutlined,
} from "@ant-design/icons";
import {TreeProps} from "antd/es/tree";
import { t } from "i18next";
import {
    isEmbeddableElement,
    isFrameElement, isImageElement, isMindmapElement, isProjectLinkElement,
    isStickyNotesElement,
    isTextElement
} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import Icon, {LoadingOutlined} from "@ant-design/icons";
import {filterNodes, loop, loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import {isElementInContent,getElementColor, getElementTitle,getElementIcon } from "@/elementUtility";
import {getNoteJsonDoc, getProjectByIds} from "@model/note";
import {getCardByIds, getCardDoc, getLibraryByLibraryId} from "@model/card";
import {dbGetHighlight} from "@model/highlight";
import {ipcInvoke} from "@/common/ipc";
import {postMessage} from "@/common/event";
import {
    EVENT_DELETE_LEFT_CARD,
    EVENT_OPEN_LIBRARY_ITEM,
    EVENT_REFRESH_CONTENT_BOOKMARK_,
    MENU_SEPARATOR
} from "@/Const";
import {
    IconAddToFavor,
    IconAddToFavorNew,
    IconBoard,
    IconCopyLink,
    IconDelete,
    IconFavorFolderNew, IconRemoveFavorNew,
    IconRename
} from "@/Icon";
import {mutateElement} from "../../../@excalidraw/packages/excalidraw";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import {getProjectContentFilter} from "@model/projectContentFilter";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";

type DataNode = FieldDataNode<{
    key:string;
    title?:string;
    editValue?:string;
    isEditable?:boolean;
    isFolder:boolean;
    drawJson:any;
    children?:any;
    icon:any;
    isSelected?:boolean;
    isHover?:boolean;
}>

/**
 * 做个全局缓存...
 */
export const globalMapAnnoCount:any = {};

const TreeListContentContent = forwardRef((props:{onAction:any,style:any,activeTab:any,height:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onRefreshElement:onRefreshElement,
        onRefreshSingleElement:onRefreshSingleElement,
        onRefreshAnnoCount:refreshAnnoCount,
        onClearSelected:onClearSelected
    }))

    const [expandKeys,setExpandKeys] = useState([]);
    const [treeSelectedKeys,setTreeSelectedKeys] = useState([]);
    const [arrayTreeData,setArrayTreeData] = useState<any>([]);
    const [isPresentMode,setIsPresentMode] = useState(false);
    const mArrayProjectsCache = useRef<any>([]);//当前projectlink的项目缓存.
    const mArrayElementsCache = useRef(null);//上一次的所有元素缓存.
    const mArrayLibrarysCache = useRef<any>([]);//库中的一些数据，有些数据并没有存在element.customData.generationData中。。。。
    const [hoveredKey,setHoveredKey] = useState('');
    const mLastTime = useRef(0);
    const mTimeoutId = useRef(0);
    const mArrayTreeData = useRef<any>(null);
    const mArrayContentElements = useRef<any>(null);

    /**
     * 刷新单个元素
     * @param element
     */
    const onRefreshSingleElement = (element)=>{
        const arrayNew = [...arrayTreeData];
        loop(arrayTreeData,element.id,(node, i, data, parent)=>{
            node.title = node.editValue = getElementTitle(element);
            node.element = element;
        });
        setArrayTreeData(arrayNew);
    }

    /**
     * 选择标题
     */
    const onClearSelected = ()=>{
        setTreeSelectedKeys([]);
    }

    const getSwitcherIcon = (hasVisible)=>{
        return <Icon component={() => <img className='img-10' style={{marginTop:'0px',opacity:hasVisible?'1':'0',pointerEvents:'none'}} src={getImagePathWithTheme('tree_icon')}/>}/>;
    }

    /**
     * 排序元素.
     * @param arrayElements
     * @param contentFilterSort
     */
    const orderElement = (arrayElements,contentFilterSort)=>{
        const szSortType = contentFilterSort?.sortBy || 'sort by createDate';
        const szOrderBy = contentFilterSort?.orderBy || 'date desc';
        if("sort by name" === szSortType){
            if("a-z" === szOrderBy){
                arrayElements.sort((a,b)=>{
                    // if(a.name == undefined || b.name == undefined)return 0;
                    return getRealElementTitle(a).localeCompare(getRealElementTitle(b));
                })
            }else if("z-a" == szOrderBy){
                arrayElements.sort((a,b)=>{
                    // if(a.name == undefined || b.name == undefined)return 0;
                    return getRealElementTitle(b).localeCompare(getRealElementTitle(a));
                })
            }
        }else if("sort by createDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayElements.sort((a,b)=>{
                    if (a.created && b.created){
                        return a.created - b.created;
                    }
                    return 0;
                })
            }else if("date desc" == szOrderBy){
                arrayElements.sort((a,b)=>{
                    if (a.created && b.created){
                        return b.created - a.created;
                    }
                    return -1;
                })
            }
        } else if("sort by updateDate" == szSortType){
            if("date asc" == szOrderBy){
                arrayElements.sort((a,b)=>{
                    return a.updated - b.updated;
                })
            }else if("date desc" == szOrderBy){
                arrayElements.sort((a,b)=>{
                    return b.updated - a.updated;
                })
            }
        }
    }

    /**
     * 刷新列表--从element转到node
     * @param arrayElements
     * @param arraySelectLibraryTypes 选中的类型
     */
    const onRefreshElement = async (arrayElements:any,arrayLibraryTypes:any,contentFilterSort:any,mSearchKey:any)=>{
        let arrayContentElements = arrayElements.filter(p=>isElementInContent(p));

        //取project项目，用于名称的显示
        const arrayProjectLinksElements = arrayContentElements.filter(p=>isProjectLinkElement(p));
        const arrayProjectIds:any = [];
        for (let i=0;i<arrayProjectLinksElements.length;i++){
            const projectElement = arrayProjectLinksElements[i];
            if (projectElement?.customData?.projectId == PROJECT_ID)continue;
            // if (!mArrayProjectsCache.current.some(p=>p?.id == projectElement?.customData?.projectId))//name会更新，必须全部重新刷新.
            {
                arrayProjectIds.push(projectElement?.customData?.projectId);
            }
        }
        if (PROJECT_ID){
            arrayProjectIds.push(PROJECT_ID);
        }
        let arrayProjects:any = await getProjectByIds(arrayProjectIds);
        arrayProjects = arrayProjects.filter(p=>p != undefined && p?.isDeleted != 1);
        //过滤--项目必须存在的
        arrayContentElements = arrayContentElements.filter((p)=>{
            if (isProjectLinkElement(p)){
                return arrayProjects.some(project=>project.id == p.customData?.projectId);
            }
            return true;
        })
        //查项目doc
        for (let i=0;i<arrayProjects.length;i++){
            const project = arrayProjects[i];
            if (project){
                project.doc = await getNoteJsonDoc(project.id);
            }
        }
        //删除本项目的.
        // const nIndex = mArrayProjectsCache.current.findIndex(p=>p?.id == PROJECT_ID);
        // if (nIndex != -1){
        //     mArrayProjectsCache.current.splice(nIndex,1);
        // }
        //全清.---为了右侧栏的重命名，不能要缓存了。库里面的可能也不能要了。。。。。
        mArrayProjectsCache.current.length = 0;
        mArrayProjectsCache.current.push(...arrayProjects);

        //取库中的一些数据，用于名称显示,数量.
        const arrayLibrarysElments = arrayContentElements.filter(p=>isLiveVideoElement(p) || isFileVideoElement(p) || isLiveVideoElement(p) || isPdfFileElement(p));
        const arrayLibraryIds:any = [];
        for (let i=0;i<arrayLibrarysElments.length;i++){
            const libraryElements = arrayLibrarysElments[i];
            if (!mArrayLibrarysCache.current.some(p=>p?.id == libraryElements?.customData?.generationData?.id)){
                arrayLibraryIds.push(libraryElements?.customData?.generationData?.id);
            }
        }
        const arrayLibrarys = await getCardByIds(arrayLibraryIds);
        mArrayLibrarysCache.current.push(...arrayLibrarys);

        if (!contentFilterSort){
            contentFilterSort = await getProjectContentFilter(PROJECT_ID);
        }
            //先排序.
        orderElement(arrayContentElements,contentFilterSort);

        let arrayData:any = [];
        const arrayFrames:any = [];
        for (let i=0;i<arrayContentElements.length;i++){
            const element = arrayContentElements[i];
            if (element.frameId)continue;
            if (!hasContainLibraryType(arrayLibraryTypes,element))continue;
            //没有frameid的，才需要
            let node = elementToNode(element);
            if (isFrameElement(element)){
                node.isFolder = true;
                //添加下面的所有.
                const arrayFrameChildren = arrayContentElements.filter(p=>!isFrameElement(p) && p.frameId == element.id);
                const arrayChildNode:any = [];
                for (let j=0;j<arrayFrameChildren.length;j++){
                    const ele = arrayFrameChildren[j];
                    if (!hasContainLibraryType(arrayLibraryTypes,ele))continue;
                    const nodeSub = elementToNode(ele);
                    arrayChildNode.push(nodeSub);
                }
                node.children = arrayChildNode;
                node.switcherIcon = getSwitcherIcon(false);
                arrayFrames.push(node);
            }else{
                arrayData.push(node);
            }
        }

        //frame排序----只有按名称排序的时候才需要这个处理...
        if (contentFilterSort?.sortBy == 'sort by name'){
            if (contentFilterSort.orderBy == 'a-z'){
                arrayFrames.sort((a,b)=>{
                    const iA = getSafeInt(a.title);
                    const iB = getSafeInt(b.title);
                    if (iA != 0 && iB != 0){
                        return iA - iB;
                    }
                    return a.title.localeCompare(b.title);
                })
            }else{
                arrayFrames.sort((a,b)=>{
                    const iA = getSafeInt(a.title);
                    const iB = getSafeInt(b.title);
                    if (iA != 0 && iB != 0){
                        return iB - iA;
                    }
                    return b.title.localeCompare(a.title);
                })
            }
        }


        //判断是否需要展开frame
        const arrayExpandKeys:any = [...expandKeys];
        for (let i=0;i<arrayFrames.length;i++){
            const frame = arrayFrames[i];
            const oldFrame = arrayTreeData.find(p=>p.id == frame.id);
            if (!oldFrame)continue;
            if (frame.children.length > oldFrame.children?.length){
                //有增加...
                if (!arrayExpandKeys.some(p=>p == frame.key)){
                    arrayExpandKeys.push(frame.key);
                }
            }
        }
        setExpandKeys(arrayExpandKeys);

        arrayData.splice(0,0,...arrayFrames);
        if (mSearchKey){
            arrayData = filterNodes(arrayData,mSearchKey);
        }
        mArrayTreeData.current = arrayData;
        setArrayTreeData(arrayData);

        let newElement:any = null;
        if (mArrayContentElements.current && mArrayContentElements.current.length >0 && arrayContentElements.length > mArrayContentElements.current.length){
            //有新增的content元素---
            for (let i=arrayContentElements.length - 1;i>= 0;i--){
                const ele = arrayContentElements[i];
                if (!mArrayContentElements.current.some(p=>p.id == ele.id)){
                    //不存在...
                    newElement = ele;
                    break;
                }
            }
        }

        mArrayContentElements.current = arrayContentElements;

        //刷新注记
        clearTimeout(mTimeoutId.current);
        mTimeoutId.current = setTimeout(()=>{
            refreshAnnoCount();
        },300);

        //滚动到最后一个。。。
        if (newElement){
            //选中这一个.
            setTreeSelectedKeys([newElement.id]);
            setTimeout(()=>{
                const dom = document.getElementById('treelist-content-'+newElement.id);
                if (dom){
                    dom.scrollIntoView();
                }
            },200)
        }
    }

    /**
     * 刷新注记的数量....
     */
    const refreshAnnoCount = async ()=>{
        const arrayNewData = [...mArrayTreeData.current];
        await loopAllNodeAsync(arrayNewData,async (node)=>{
            if (isFileVideoElement(node.element) || isLiveVideoElement(node.element) || isAudioFileElement(node.element)){
                const highlight = await dbGetHighlight(node.element.customData?.generationData?.id);
                if (highlight){
                    node.annoCount = highlight.data?.length;
                }
            }else if (isPdfFileElement(node.element)){
                const annos = await ipcInvoke('get-annotations',{fileId:node.element.customData?.generationData?.id});
                node.annoCount = annos?.length;
            }else if (isNoteElement(node.element)){
                const arrayAnnos = await getLibraryByLibraryId(node.element.customData?.generationData?.id);
                node.annoCount = arrayAnnos.length;
            }
            globalMapAnnoCount[node.key] = node.annoCount;
        })
        setArrayTreeData(arrayNewData);

        postMessage(EVENT_REFRESH_CONTENT_BOOKMARK_,{elements:mArrayContentElements.current})
    }

    /**
     * 选择的是否包含这种类型....
     * @param arrayLibraryTypes
     * @param element
     */
    const hasContainLibraryType = (arrayLibraryTypes:any,element:any)=>{
        if (isPdfFileElement(element)){
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'pdf' && isPdf(element.customData.generationData.fileName));
        }else if (isFileVideoElement(element)){
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'video' && isVideo(element.customData.generationData.fileName));
        }else if (isLiveVideoElement(element)){//视频包括本地视频和在线视频---跟library分的又不一样。。。。完全没有可以兼容的地方
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'liveVideo' && (isLiveVideoType(element.customData.generationData.type)));
        }else if (isAudioFileElement(element)){
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'audio' && isAudio(element.customData.generationData.fileName));
        }
        else if (isFileElement(element)){
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'file' && !isPdf(element.customData.generationData.fileName) && !isVideo(element.customData.generationData.fileName) && !isAudio(element.customData.generationData.fileName));
        }
        else if (isNoteElement(element)){
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'card');
        }else if (isNoteElement(element)){
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'text');
        }else if (isEmbeddableElement(element)){
            return arrayLibraryTypes.some(p=>p.isChecked && p.value == 'webLink');
        }
        return arrayLibraryTypes.some(p=>p.isChecked && p.value == element.type);
    }

    /**
     * element-->node
     * @param element
     */
    const elementToNode = (element:any)=>{
        const node = {
            key:element.id,
            title:element.name,
            editValue:element.name,
            isEditable:false,
            isFolder:false,
            element:element,
        }
        node.title = node.editValue = getRealElementTitle(element);
        node.color = getElementColor(element);
        if (globalMapAnnoCount[node.key]){
            node.annoCount = globalMapAnnoCount[node.key];
        }
        if (isFileVideoElement(element)){
            const library = mArrayLibrarysCache.current.find(p=>p.customData?.generationData?.id);
            if (library){
                node.annoCount = library.videoAnn;
            }
        }
        return node;
    }

    /**
     * 实际的标题，有些element元素中并没有标题。这里还要额外处理...
     * @param element
     */
    const getRealElementTitle = (element:any)=>{
        let szTitle = '';
        if (isProjectLinkElement(element)){
            const project = mArrayProjectsCache.current.find(p=>p?.id == element?.customData?.projectId);
            if (element.customData?.boardId){
                if (project?.doc){
                    loopAllNode(project.doc.canvas,(item)=>{
                        if (!szTitle && item.key == element.customData?.boardId){
                            szTitle = item.title;
                        }
                    })
                }
            }else{
                szTitle = project?.name || t('Untitled');
            }
        }else if (isLiveVideoElement(element) || isLiveVideoElement(element)){
            const library = mArrayLibrarysCache.current.find(p=>p?.id == element.customData?.generationData?.id);
            szTitle = library?.name || t('Untitled');
        }
        else{
            szTitle = getElementTitle(element) || t("Untitled");
        }
        return szTitle;
    }


    const onExpand:TreeProps["onExpand"]=((expandedKeys:any, expanded) => {
        setExpandKeys(expandedKeys);
    })

    /**
     * tree选择.....
     */
    const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {
        //转到这个element--
        setTreeSelectedKeys(selectedKeys);
        props.onAction('zoomTo',{element:info.node.element})
    });

    const onTreeMouseEnter: TreeProps["onMouseEnter"] = (event) => {
        if (isPresentMode) return;
        setHoveredKey(event.node.key);
        const arrayNew = [...arrayTreeData];
        for (let i=0;i<arrayNew.length;i++){
            const node = arrayNew[i];
            if (isFrameElement(node.element)){
                node.switcherIcon = getSwitcherIcon(false);
            }
        }
        loop(arrayNew,event.node.key,(node, i, data, parent)=>{
            if (isFrameElement(node.element)){
                if (node.children?.length > 0){
                    node.switcherIcon = getSwitcherIcon(true);
                }
            }
        })
        setArrayTreeData(arrayNew);
    }

    const onTreeMouseLeave: TreeProps["onMouseLeave"] = (event) => {
        setHoveredKey('')

        const arrayNew = [...arrayTreeData];
        for (let i=0;i<arrayNew.length;i++){
            const node = arrayNew[i];
            if (isFrameElement(node.element)){
                node.switcherIcon = getSwitcherIcon(false);
            }
        }
        setArrayTreeData(arrayNew);
    }


    const getMenus = (node:any) => {
        const renameItem = getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, (event) => {
            event.domEvent.stopPropagation();
            const arrayDatas = [...arrayTreeData];
            node.isEditable = true;
            setArrayTreeData(arrayDatas);
            setTimeout(()=>{
                const dom = document.getElementById(`txt-edit-${node.key}`);
                if (dom){
                    dom.focus();
                }
            },100)
        });
        const menus = [
            getItem(node.element.extra?.favor == 1?t("RemoveFromBookmark"):t("AddToBookmark"), 'addToBookmark', node.element.extra?.favor == 1?<IconRemoveFavorNew/>:<IconAddToFavorNew/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                if (!node.element.extra){
                    node.element.extra = {};
                }
                const extra = {...node.element.extra}
                if(extra.favor == 1){
                    extra.favor = 0;
                }else{
                    extra.favor = 1;
                }
                extra.favirateTime = Date.now();
                mutateElement(node.element,{extra:extra});
            }),

            // getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {
            //
            // }),
            getItem(t("Remove"), 'remove', <IconDelete/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                //删除这个元素..
                if (window.deleteElement){
                    window.deleteElement(node.key);
                }
            }),
            getItem(t("Delete from library"), 'deleteFromLibrary', <IconDelete/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                if (window.deleteElement){
                    window.deleteElement(node.key,true);
                }
            }),
        ];

        if (isPdfFileElement(node.element) || isImageElement(node.element) || isFrameElement(node.element) || isFileVideoElement(node.element) || isFileElement(node.element) || isLiveVideoElement(node.element)){
            menus.splice(0,0,renameItem)
        }else{

        }
        if (isStickyNotesElement(node.element) || isMindmapElement(node.element) || !node.element?.customData?.generationData?.id){
            const nIndex = menus.findIndex(p=>p.key == 'deleteFromLibrary');
            if(nIndex){
                menus.splice(nIndex,1);
            }
        }

        return menus;
    }


    // input 改变
    const onChange = (e: any, key: any) => {
        const data = [...arrayTreeData];
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
        });
        setArrayTreeData(data)
    };

    //丢失焦点
    const onBlur = (e: any, key: any) => {
        const data = [...arrayTreeData];
        let node:any;
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
            item.isEditable = false;
            node = item;
        });

        //也修改同一个library的name
        if (node){
            loopAllNode(data,(item)=>{
                if (node.key != item.key){
                    if (node.element?.customData?.generationData?.id && node.element?.customData?.generationData?.id == item.element?.customData?.generationData?.id){
                        item.title = item.editValue = node.title;
                    }
                }
            })
        }

        setArrayTreeData(data)

        //更新画布上的name...
        if (window.renameElement){
            window.renameElement(node?.element?.id,node.title);
        }
    }

    return<>
        <ConfigProvider
            theme={{
                components: {
                    Tree:{
                        colorPrimary: 'var(--primary-color)',
                        directoryNodeSelectedBg:isPresentMode?'#444444':'var(--select-background-color)',
                        indentSize:0,
                        borderRadius:0,
                        titleHeight:32,
                    }
                }
            }}
        >
            <DirectoryTree
                rootStyle={props.style}
                className="tree-fuck-ant-left-align-info"
                // switcherIcon={<Icon component={() => <img className='img-10' style={{marginTop:'0px'}} src={getImagePathWithTheme('tree_icon')}/>}/>}
                expandedKeys={expandKeys}
                onExpand={onExpand}
                onSelect={onSelect}
                treeData={arrayTreeData}
                selectedKeys={treeSelectedKeys}
                onRightClick={(info)=>{
                    setTreeSelectedKeys([info.node.key as string])
                }}
                height={props.height - 48}
                showIcon={false}
                blockNode={true}
                onMouseEnter={onTreeMouseEnter}
                onMouseLeave={onTreeMouseLeave}
                // draggable={treeDraggable}
                // onDragOver={onDragOver}
                // onDragStart={onDragStart}
                // onDragEnd={onDragEnd}
                // onDrop={onDrop}
                titleRender={(nodeData:DataNode)=>{
                    if(nodeData.isEditable){
                        return(
                            <div style={{display: "flex", width: "206px", alignItems: "center"}}>
                                <span className={'flex-center img-16'}>
                                        {getElementIcon(nodeData.element, nodeData.color)}
                                    </span>

                                <Input id={`txt-edit-${nodeData.key}`} className='default-font-size font-family-regular'
                                       value={nodeData.editValue == t("Untitled") ? '' : (nodeData.editValue || '')}
                                       style={{
                                           color: "var(--text-color-dark-color)",
                                           marginLeft: '6px',
                                           paddingLeft: '0px',
                                           marginBottom: '0px',
                                           flexGrow: 1,
                                           paddingTop: '6px',
                                       }}
                                       variant={"borderless"}
                                       autoFocus={true}
                                       onKeyDown={(event)=>{
                                           if (event.key == KEYS.ENTER) {
                                               const txt = document.getElementById(`txt-edit-${nodeData.key}`);
                                               if (txt) {
                                                   txt.blur();
                                               }
                                           }
                                       }}
                                    // onKeyPress={(e)=>onCanvasKeyPress(e,nodeData.key)}
                                       onChange={(e)=>onChange(e,nodeData.key)}
                                       onBlur={(e)=>onBlur(e,nodeData.key)}
                                />
                                {/*<div style={{width:'16px',height:'16px',marginLeft:'16px'}}></div>*/}
                            </div>
                        )
                    } else {
                        return (
                            <Dropdown overlayClassName='default-dropdown-style' menu={{items:getMenus(nodeData)}} trigger={['contextMenu']} overlayStyle={{width:'auto'}} onOpenChange={(open)=>{
                                if (open) {
                                    //转到
                                    // props.onAction('zoomTo',{element:nodeData.element})
                                }
                            }}>
                                <div className='flex-row-vertical-center' id={'treelist-content-'+nodeData.key} style={{display:"flex",width:"auto",alignItems:"center",paddingRight:'8px'}}>
                                    <span className={'flex-center img-16'}>
                                        {getElementIcon(nodeData.element,nodeData.color)}
                                    </span>

                                    <Input className='default-font-size font-family-regular span-single-line'
                                           readOnly={true} variant={"borderless"}
                                           bordered={false}
                                           style={{
                                               color: isPresentMode ? "white" : ((treeSelectedKeys[0] == nodeData.key) ? "var(--text-color-dark-color)" : "var(--text-color-dark-color)"),
                                               marginLeft: '6px',
                                               paddingLeft: '0px',
                                               cursor: "pointer",
                                               flexGrow: '1',
                                               paddingTop: '6px',
                                               marginBottom: '0px',
                                               paddingRight: '8px',
                                           }}
                                           value={nodeData.title}/>

                                    {
                                        hoveredKey == nodeData.key?
                                            <div className={'flex-row-vertical-center'}>
                                                {
                                                    (isNoteElement(nodeData.element) || isPdfFileElement(nodeData.element) || isFileVideoElement(nodeData.element) || isLiveVideoElement(nodeData.element)) &&
                                                    <img className={'img-16 mr-6'} src={getImagePathWithThemeSvg('content_open')} onClick={(event)=>{
                                                        if (event.ctrlKey || event.metaKey) {
                                                            global.g_isCtrlPressed = true;
                                                            setTimeout(()=>{
                                                                global.g_isCtrlPressed = false;
                                                            },2000);
                                                        }
                                                        // props.onAction('openElement', {element:nodeData.element});
                                                        postMessage(EVENT_OPEN_LIBRARY_ITEM,{id:nodeData.element.customData?.generationData?.id,deeplink:{}});
                                                    }}/>
                                                }
                                                <Dropdown menu={{
                                                    items: getMenus(nodeData),
                                                }} trigger={['click']} align={{offset: [26, -26]}} onOpenChange={(e)=>{
                                                    if (e) {
                                                        // mRightData.current = {node:nodeData};
                                                    }
                                                }}>
                                                    <div className={'flex-center'} style={{
                                                        height: '100%',
                                                        width: '26px',
                                                        flexShrink: '0',
                                                        marginRight: '0px',
                                                    }} onClick={(event)=>{
                                                        event.stopPropagation();
                                                    }}>
                                                        <img className='img-medium-small'
                                                             style={{flexShrink: '0',opacity:(hoveredKey == nodeData.key)?'1':'0'}}
                                                             src={getImagePathWithTheme("horizontal_content_more.svg")} />
                                                    </div>
                                                </Dropdown>
                                            </div> :<>
                                                {
                                                    nodeData.annoCount > 0 &&
                                                    <span className={'flex-center'} style={{
                                                        background:'var(--content-anno-count-background)',
                                                        borderRadius:'10px',
                                                        height:'20px',
                                                        minWidth:'20px',
                                                        fontSize:'10px',
                                                        color:'var(--text-color)'
                                                    }}>{nodeData.annoCount}</span>
                                                }
                                            </>
                                    }
                                </div>
                            </Dropdown>
                        )
                    }
                }}
            />
        </ConfigProvider>
    </>
})

export default TreeListContentContent;